import { FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AdvancedFilterRow, SingleSelectionAdvancedFilter } from 'shared/components/AdvancedFilter';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectSuburbanFloorsFilter } from 'shared/selectors/advancedFilters';

export const SuburbanFloorsContainer: FC = () => {
  const { label, value, options } = useSelector(selectSuburbanFloorsFilter);

  const onChange = useFilterChangeCallback();

  const handleSuburbanFloorsChange = useCallback(
    (newValue: 1 | 2 | null) => {
      const valueMin = newValue;
      const valueMax = newValue === 1 ? /* istanbul ignore next */ 1 : null;

      onChange({ action: 'setFloorsMin', arguments: [valueMin] }, { action: 'setFloorsMax', arguments: [valueMax] });
    },
    [onChange],
  );

  return (
    <AdvancedFilterRow label={label}>
      <SingleSelectionAdvancedFilter value={value} options={options} onFilterChange={handleSuburbanFloorsChange} />
    </AdvancedFilterRow>
  );
};
